import axios from 'axios';

export type ExportColumnKey =
  | 'patientId'
  | 'patientName'
  | 'hospitalFileId'
  | 'hospitalSite'
  | 'dietitianId'
  | 'date'
  | 'time'
  | 'brand'
  | 'product'
  | 'portionValue'
  | 'portionUnit'
  | 'calories'
  | 'protein'
  | 'carbs'
  | 'fat'
  | 'goalType';

export interface ExportColumnOption {
  key: ExportColumnKey;
  label: string;
  clinicalOnly?: boolean;
}

export const EXPORT_COLUMN_OPTIONS: ExportColumnOption[] = [
  { key: 'patientId', label: 'MLAS Patient ID' },
  { key: 'patientName', label: 'Patient Name', clinicalOnly: true },
  { key: 'hospitalFileId', label: 'Hospital File ID', clinicalOnly: true },
  { key: 'hospitalSite', label: 'Hospital/Site' },
  { key: 'dietitianId', label: 'Dietitian ID' },
  { key: 'date', label: 'Date' },
  { key: 'time', label: 'Time' },
  { key: 'brand', label: 'Brand' },
  { key: 'product', label: 'Product' },
  { key: 'portionValue', label: 'Portion Value' },
  { key: 'portionUnit', label: 'Portion Unit' },
  { key: 'calories', label: 'Calories' },
  { key: 'protein', label: 'Protein' },
  { key: 'carbs', label: 'Carbs' },
  { key: 'fat', label: 'Fat' },
  { key: 'goalType', label: 'Goal Type' }
];

export const getExportColumnOptions = (exportType: 'clinical' | 'research') =>
  EXPORT_COLUMN_OPTIONS.filter(
    column => exportType === 'clinical' || !column.clinicalOnly
  );

export interface ExportFoodDataPayload {
  exportType: 'clinical' | 'research';
  dateFrom: string;
  dateTo: string;
  columns?: ExportColumnKey[];
  clinicId?: number | number[];
  dietitianId?: number | number[];
  patientId?: number;
}

export interface FoodLog {
  patientId: number;
  patientName?: string;
  hospitalFileId?: string;
  hospitalSite?: string;
  dietitianId?: number | string;
  mealId: number;
  mealTitle: string;
  itemName: string;
  brandName: string | null;
  productName: string | null;
  brand?: string | null;
  product?: string | null;
  portion: string;
  portionValue?: number | string;
  portionUnit?: string;
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
  date: string;
  time: string;
  goalType?: string;
}

export interface PatientSummary {
  patientId: number;
  patientName?: string;
  hospitalFileId?: string;
  hospitalSite?: string;
  dietitianId?: number | string;
  totalMeals: number;
  totalItems: number;
  totalCalories: number;
  totalProtein: number;
  totalCarbs: number;
  totalFat: number;
  activeGoalTypes: string[];
  averageDailyCalories?: number;
  percentageOfDaysLogged?: number;
  weightChange?: number | string;
}

export interface ExportFoodDataResponse {
  status: boolean;
  data: {
    code: number;
    message: string;
    exportType: string;
    dateFrom: string;
    dateTo: string;
    foodLogs: FoodLog[];
    patientSummaries: PatientSummary[];
  };
}

export const exportFoodData = async (
  payload: ExportFoodDataPayload
): Promise<ExportFoodDataResponse> => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${process.env.REACT_APP_ENDPOINT}/exports/food-data`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data;
};
